import { render, staticRenderFns } from "./CornerItem.vue?vue&type=template&id=2fed4e8f&"
import script from "./CornerItem.vue?vue&type=script&lang=js&"
export * from "./CornerItem.vue?vue&type=script&lang=js&"
import style0 from "./CornerItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CornerItem.vue"
export default component.exports